module.exports = __webpack_public_path__ + "static/media/Blur-asset-1.21a8709e.png";